module.exports = __webpack_public_path__ + "img/Fondo-blanco-movil.398407a8.png";